import { render, staticRenderFns } from "./PromoPageModal.vue?vue&type=template&id=2fc665be&scoped=true&"
import script from "./PromoPageModal.vue?vue&type=script&lang=ts&"
export * from "./PromoPageModal.vue?vue&type=script&lang=ts&"
import style0 from "./PromoPageModal.vue?vue&type=style&index=0&id=2fc665be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc665be",
  null
  
)

export default component.exports